import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { IReport, IReportTemplateFE, SINGLE_KEY } from "@ryde/shared";

export const useReportTitles = (
  report: IReport | undefined,
  reportTemplate: IReportTemplateFE | undefined,
) => {
  const { t } = useTranslation();
  const reportTitle = useMemo(() => {
    if (report?.translationKey) {
      return t(report.translationKey);
    }

    if (report?.name) {
      return report.name;
    }

    if (reportTemplate?.translationKey) {
      return t(reportTemplate.translationKey);
    }

    return t(`report.${SINGLE_KEY}`);
  }, [report?.name, report?.translationKey, reportTemplate?.translationKey, t]);

  const reportDescription = useMemo(() => {
    if (report?.descriptionTranslationKey) {
      return t(report.descriptionTranslationKey);
    }

    if (report?.description) {
      return report.description;
    }

    return "";
  }, [report?.description, report?.descriptionTranslationKey, t]);

  return { reportTitle, reportDescription };
};
